import React from 'react'

const AzimRedSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 23.298 29.122'
    >
      <path
        id='ticket-svgrepo-com_2_'
        data-name='ticket-svgrepo-com (2)'
        d='M24.557,10.737H27.3V4.912A2.912,2.912,0,0,0,24.386,2H20.017a4.368,4.368,0,1,1-8.737,0H6.912A2.912,2.912,0,0,0,4,4.912v5.824H6.74a1.456,1.456,0,0,1,0,2.912H4V28.21a2.912,2.912,0,0,0,2.912,2.912H24.386A2.912,2.912,0,0,0,27.3,28.21V13.649h-2.74a1.456,1.456,0,0,1,0-2.912ZM13.593,13.649h-2.74a1.456,1.456,0,0,1,0-2.912h2.74a1.456,1.456,0,1,1,0,2.912Zm6.852,0H17.7a1.456,1.456,0,0,1,0-2.912h2.74a1.456,1.456,0,1,1,0,2.912Z'
        transform='translate(-4 -2)'
        fill='#f73a00'
      />
    </svg>
  )
}

export default AzimRedSvg
